export class ChangeDrawOrder {
    changeOrder(attachMap) {
        return this.order;
    }
    change(vb, slotAttachMap) {
        return true;
    }
}
